module.exports = __webpack_public_path__ + "static/laboheme0s-d284db5fedb335f69f7ad5683fff8cd7.jpg";